import usePDPData from '@/app/(pdp)/_utils/use-pdp-data';
import BabyPDPVariantProvider from '@/app/(pdp)/context/baby-pdp-variant-context/provider';
import Content from './content';
interface Props {
  productSlug?: string;
  closeHandler: () => void;
}
const BabyPDP = ({
  productSlug,
  closeHandler
}: Props) => {
  const isOpen = !!productSlug;
  const {
    data,
    isLoading
  } = usePDPData(productSlug);
  return <>
            <div className={`absolute inset-0 z-20 transition-opacity duration-300 ${isOpen ? 'visible opacity-100' : 'invisible opacity-0'}`} onClick={closeHandler} />

            <div className={`absolute bottom-0 left-0 right-0 z-30 w-full transform rounded-t-2xl bg-white shadow-lg transition-transform duration-300 ${isOpen ? 'translate-y-0' : 'translate-y-full'}`}>
                {isOpen && productSlug && <BabyPDPVariantProvider key={productSlug} product={data} isLoading={isLoading}>
                        <Content closeHandler={closeHandler} productSlug={productSlug} />
                    </BabyPDPVariantProvider>}
            </div>
        </>;
};
export default BabyPDP;